// extracted by mini-css-extract-plugin
export default {"fontFamily":"Map_fontFamily__zQTBP"};